import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import * as moment from 'moment';
import {select, Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {loadAllMitarbeiterStart} from '../../store/actions/getAllMitarbeiter.actions';
import {getFilteredMitarbeiterStart} from '../../store/actions/getFilteredMitarbeiter.actions';

@Component({
    selector: 'app-mitarbeiter-filter',
    templateUrl: './mitarbeiter-filter.component.html',
    styleUrls: ['./mitarbeiter-filter.component.scss'],
})
export class MitarbeiterFilterComponent {

  constructor(private store: Store<{ mitarbeiterverwaltung: State }>, public dialog: MatDialog) {
  }

  public filterForm = new FormGroup({
    search: new FormControl(''),
    deleted: new FormControl(''),
  });

  public search(): void{

    let searchString = '';
    // Suche ausgefüllt
    if (this.filterForm.value.search){
      searchString += 'search';
      sessionStorage.setItem('mitarbeiterSuche', this.filterForm.value.search);
    }
    else{
      sessionStorage.setItem('mitarbeiterSuche', '');
    }
    if (this.filterForm.value.deleted){
        searchString += 'check';
        sessionStorage.setItem('mitarbeiterDeaktiviert', this.filterForm.value.deleted);
    }
    else{
      sessionStorage.setItem('mitarbeiterDeaktiviert', 'false');
    }

    sessionStorage.setItem('mitarbeiterSearchString', searchString);
    this.store.dispatch(getFilteredMitarbeiterStart({string: searchString, item: this.filterForm.value}));
  }
}
